module.exports = __webpack_public_path__ + "img/cuhk-20221123.509e9c30.jpg";